import React, { useState } from 'react';
import { X, Save, Smartphone } from 'lucide-react';
import { Button, Input } from '../../common';
import tenantsService from '../../../services/api/tenants.service';

const CreateInstanceModal = ({ onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    instanceName: '',
    integration: 'WHATSAPP-BAILEYS',
    qrcode: true,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.instanceName.trim()) {
      setError('Nome da instância é obrigatório');
      return;
    }

    try {
      setLoading(true);
      await tenantsService.createEvolutionInstance({
        instanceName: formData.instanceName,
        integration: formData.integration,
        qrcode: formData.qrcode,
        webhook: {
          enabled: true,
          url: `${window.location.origin}/wa/webhook`,
          events: ['MESSAGES_UPSERT']
        }
      });
      onSuccess();
    } catch (err) {
      setError(err.message || err.detail || 'Erro ao criar instância');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
            <Smartphone className="w-6 h-6 text-primary-500" />
            Nova Instância Evolution
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label="Nome da Instância"
            name="instanceName"
            value={formData.instanceName}
            onChange={handleChange}
            placeholder="meu-bot-whatsapp"
            required
            helperText="Nome único para identificar esta instância"
            error={error}
          />

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Integração
            </label>
            <select
              name="integration"
              value={formData.integration}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-transparent"
            >
              <option value="WHATSAPP-BAILEYS">WhatsApp Baileys</option>
            </select>
            <p className="text-xs text-gray-500 mt-1">
              Tipo de integração com WhatsApp
            </p>
          </div>

          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              name="qrcode"
              checked={formData.qrcode}
              onChange={handleChange}
              className="w-5 h-5 rounded border-gray-300 text-primary-500 focus:ring-primary-400"
            />
            <span className="text-sm text-gray-700">
              Habilitar QR Code
            </span>
          </label>

          <div className="p-4 bg-blue-50 rounded-lg">
            <p className="text-sm text-blue-700">
              💡 Após criar a instância, escaneie o QR Code com seu WhatsApp para conectar.
            </p>
          </div>
        </form>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            loading={loading}
            leftIcon={<Save className="w-4 h-4" />}
          >
            Criar Instância
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateInstanceModal;